export const enum WALLET_NAMES {
  MetaMask = "MetaMask",
  Ledger = "Ledger",
}
